{
   let pageTypeContainer = document.querySelectorAll('[data-active-page-type]');
   let pageTypeDiv = document.querySelectorAll('[data-page-type]');

   // In order to keep tab focus functionality working with a differing click event functionality,
   // we need to track whether the user has clicked on the page type form or not. This variable will
   // keep track of this so we can still use setActivePageType() and track that we previously clicked
   // on the page type form. This will also allow us to reset the highlighting when switching to using
   // tab focusing without skipping objects to tab focus on.
   let clickActivePageType = '';

   pageTypeDiv.forEach(el => {
      el.addEventListener('keydown', ev => {
         if (ev.key === 'Tab') {
            clickActivePageType = '';
         }
      });

      el.addEventListener('click', () => {
         const pageType = el.dataset.pageType;
         if (clickActivePageType == '') {
            clickActivePageType = pageType;
            setActivePageType(pageType);
            document.querySelector(`.title-input-${pageType}`)?.focus();
            return;
         }
         if (clickActivePageType !== pageType) {
            resetActivePageType();
            return;
         }
      });

      el.addEventListener('focusin', () => {
         if (clickActivePageType == '') {
            const pageTypeDiv = findParent(document.activeElement, 'data-page-type');
            if (pageTypeDiv) {
               setActivePageType(pageTypeDiv.dataset.pageType);
            }
         }
      });
   });

   window.addEventListener('click', event => {
      if (event.target.parentElement?.closest('[data-page-type]')) {
         return;
      }

      resetActivePageType();
   });

   window.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
         resetActivePageType();
      }
   });

   window.addEventListener('focusin', event => {
      let pageTypeElement = event.target.parentElement?.closest('.page-type-container');
      if (!pageTypeElement) {
         resetActivePageType();
      }
   });

   function setActivePageType(pageType) {
      document.body.style.cursor = 'pointer';

      pageTypeContainer.forEach(el => {
         el.dataset.activePageType = pageType;
      });
   }

   function resetActivePageType() {
      clickActivePageType = '';
      document.body.style.cursor = 'auto';

      pageTypeContainer.forEach(el => {
         el.dataset.activePageType = '';
      });
   }

   function findParent(element, property) {
      if (element.getAttribute(property)) {
         return element;
      }
      return element.parentElement?.closest(`[${property}]`);
   }
}
